export default __webpack_public_path__ + "locales/el-GR/FormFillingTipsDialog.json?hash=48243d7bcceb3effd0053954fccd7eab";